;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/careers/:slug\",\"regex\":\"^/careers/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/training/feedback/:id\",\"regex\":\"^/training/feedback/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/training/session/:id\",\"regex\":\"^/training/session/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/try/:slug\",\"regex\":\"^/try/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/try/:slug/recap/:id\",\"regex\":\"^/try/([^/]+)/recap/([^/]+)$\",\"paramNames\":[\"slug\",\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/try/:slug/session/:id\",\"regex\":\"^/try/([^/]+)/session/([^/]+)$\",\"paramNames\":[\"slug\",\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/careers\"},{\"path\":\"/pricing\"},{\"path\":\"/app\"},{\"path\":\"/dpa\"},{\"path\":\"/privacy-policy\"},{\"path\":\"/terms-of-use\"},{\"path\":\"/auth\"},{\"path\":\"/auth/join\"},{\"path\":\"/auth/role\"},{\"path\":\"/aws/confirm\"},{\"path\":\"/aws/link\"},{\"path\":\"/connected\"},{\"path\":\"/training/overview\"}],\"isrRoutes\":[\"/careers/:slug\"]}";globalThis["_sentryNextJsVersion"] = "15.4.10";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";
import { clientConfig } from "@workspace/sentry";

function stripPreviewToken(url: string): string {
  try {
    const parsed = new URL(url);
    parsed.searchParams.delete("preview");
    return parsed.toString();
  } catch {
    return url;
  }
}

function stripUrlProperties(bag: Record<string, unknown> | undefined): void {
  if (!bag) return;
  for (const key of Object.keys(bag)) {
    const value = bag[key];
    if ((key.endsWith("_url") || key === "url" || key === "from" || key === "to" || key === "$referrer" || key === "$initial_referrer") && typeof value === "string") {
      bag[key] = stripPreviewToken(value);
    }
  }
}

// Loaded only where it is actually configured, and even there after the page
// is up: a static import put the whole library — ~60 KB gzip — into the first
// load of every route, including the deployments that have no key at all.
if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  void import("posthog-js").then(({ default: posthog }) => {
    posthog.init(key, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
      defaults: "2025-11-30",
      name: "yolk-landing",
      // The first pageview fires before the page can clean its own URL.
      before_send: (event) => {
        if (!event) return event;
        stripUrlProperties(event.properties);
        stripUrlProperties(event.properties?.$set);
        stripUrlProperties(event.properties?.$set_once);
        stripUrlProperties(event.$set);
        stripUrlProperties(event.$set_once);
        return event;
      },
    });
  });
}

Sentry.init({
  ...clientConfig,
  beforeSend: (event, hint) => {
    if (event.request?.url) event.request.url = stripPreviewToken(event.request.url);
    return clientConfig.beforeSend ? clientConfig.beforeSend(event, hint) : event;
  },
  beforeBreadcrumb: (breadcrumb, hint) => {
    if (breadcrumb.data) stripUrlProperties(breadcrumb.data);
    return clientConfig.beforeBreadcrumb ? clientConfig.beforeBreadcrumb(breadcrumb, hint) : breadcrumb;
  },
});
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
